<div class="ce-row">
  <div class="ce-col-lg-4 ce-col-md-12 ce-col-sm-12 ce-col-12 trend-widget-container">
    <app-global-loader-wrapper [resource]="customerAnalyticsResource">
      <ng-template>
        <app-analytics-trend-widget
          title="New customers"
          metricsKey="new_customers"
          [context]="rangeContext()"
          [analytics]="customerAnalyticsResource.value()">
        </app-analytics-trend-widget>
      </ng-template>
    </app-global-loader-wrapper>
  </div>

  <div class="ce-col-lg-4 ce-col-md-12 ce-col-sm-12 ce-col-12 trend-widget-container">
    <app-global-loader-wrapper [resource]="orderAnalyticsResource">
      <ng-template>
        <app-analytics-trend-widget
          title="Orders"
          metricsKey="total_order"
          [context]="rangeContext()"
          [analytics]="orderAnalyticsResource.value()">
        </app-analytics-trend-widget>
      </ng-template>
    </app-global-loader-wrapper>
  </div>

  <div class="ce-col-lg-4 ce-col-md-12 ce-col-sm-12 ce-col-12 trend-widget-container">
    <app-global-loader-wrapper [resource]="orderAnalyticsResource">
      <ng-template>
        <app-analytics-trend-widget
          title="Gross revenue"
          metricsKey="gross_revenue"
          formatter="currency"
          [context]="rangeContext()"
          [analytics]="orderAnalyticsResource.value()">
        </app-analytics-trend-widget>
      </ng-template>
    </app-global-loader-wrapper>
  </div>
</div>

<div class="ce-row">
  <!-- Total orders -->
  <div class="ce-col-lg-6 ce-col-md-12 ce-col-sm-12 ce-col-12 order-history">
    <div class="grid spacing-16 analytics-grid">
      <app-global-loader-wrapper [resource]="orderAnalyticsResource">
        <ng-template>
          <app-analytics-widget
            class="w-100"
            title="Orders"
            subtitle="Confirmed orders in the selected period"
            metricsKey="total_order"
            [height]="260"
            [compare]="comparePeriod()"
            [context]="rangeContext()"
            [analytics]="orderAnalyticsResource.value()">
          </app-analytics-widget>
        </ng-template>
      </app-global-loader-wrapper>
    </div>
  </div>

  <!-- Total revenue, excluding taxes -->
  <div class="ce-col-lg-6 ce-col-md-12 ce-col-sm-12 ce-col-12 order-history">
    <div class="grid spacing-16 analytics-grid">
      <app-global-loader-wrapper [resource]="orderAnalyticsResource">
        <ng-template>
          <app-analytics-widget
            class="w-100"
            title="Net revenue"
            subtitle="Total revenue for your store, excluding taxes"
            metricsKey="net_revenue"
            formatter="currency"
            [height]="260"
            [analytics]="orderAnalyticsResource.value()"
            [compare]="comparePeriod()"
            [context]="rangeContext()">
          </app-analytics-widget>
        </ng-template>
      </app-global-loader-wrapper>
    </div>
  </div>

  <!-- Overall checkout funnel -->
  <div class="ce-col-lg-12 ce-col-md-12 ce-col-sm-12 ce-col-12 order-history">
    <div class="grid spacing-16 analytics-grid">
      <div class="grid-heading d-flex align-items-center justify-content-between w-100">
        <h3 class="h3-bold m-0 primary-100 d-flex align-items-start flex-column spacing-4">
          Order conversion funnel
          <span class="h4-reg primary-60">
            Track customer journey from cart to purchase completion
          </span>
        </h3>
      </div>

      <app-global-loader-wrapper [resource]="checkoutStatsResource">
        <ng-template>
          <app-funnel-chart [chartData]="checkoutStatsResource.value()" class="w-100">
          </app-funnel-chart>
        </ng-template>
      </app-global-loader-wrapper>
    </div>
  </div>

  <!-- Total customers -->
  <div class="ce-col-lg-6 ce-col-md-12 ce-col-sm-12 ce-col-12 order-history">
    <div class="grid spacing-16 analytics-grid">
      <app-global-loader-wrapper [resource]="customerAnalyticsResource">
        <ng-template>
          <app-analytics-widget
            class="w-100"
            title="Customers"
            subtitle="Customers who have signed up in the selected period"
            metricsKey="total_customers"
            [height]="260"
            [analytics]="customerAnalyticsResource.value()"
            [compare]="comparePeriod()"
            [context]="rangeContext()">
          </app-analytics-widget>
        </ng-template>
      </app-global-loader-wrapper>
    </div>
  </div>

  <!-- Total units sold -->
  <div class="ce-col-lg-6 ce-col-md-12 ce-col-sm-12 ce-col-12 order-history">
    <div class="grid spacing-16 analytics-grid">
      <app-global-loader-wrapper [resource]="productAnalyticsResource">
        <ng-template>
          <app-analytics-widget
            class="w-100"
            title="Units sold"
            subtitle="Total units sold in the selected period"
            metricsKey="purchased"
            [height]="260"
            [analytics]="productAnalyticsResource.value()"
            [compare]="comparePeriod()"
            [context]="rangeContext()">
          </app-analytics-widget>
        </ng-template>
      </app-global-loader-wrapper>
    </div>
  </div>
</div>
